import { globalState } from '@codeleap/store'
import { TypeGuards } from '@codeleap/types'
import type { Profile } from '@/services/api/session/views'

type StoreType = Record<keyof Profile, any>

export const store = globalState<StoreType>({} as StoreType)

export function answerPrompt<T extends keyof Profile>(prompt: T, value: Profile[T]) {
  store.set({ [prompt]: value })
}

export function isAnswerValue(value: unknown) {
  if (Array.isArray(value)) return value.length > 0

  return !TypeGuards.isNil(value) && value !== ''
}

export function isAnswered(prompt: keyof Profile) {
  return isAnswerValue(store.get()?.[prompt])
}

export function usePromptAnswer(prompt: keyof Profile) {
  return store.use(s => isAnswerValue(s?.[prompt]))
}

export function reset() {
  store.reset({} as StoreType)
}
